// extracted by mini-css-extract-plugin
export default {"container":"webpack-concepts-Extraction-Blocks-TextField-editor-TextFieldEditor-module__container"};